module.exports = __webpack_public_path__ + "img/cattunnel38.2c5532a0.jpg";